module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7Y2Di"))).then(() => parcelRequire('5erN3'));